import { createContext, useContext } from 'react';

type ReviewSummaryState = {
  hasExtractionTemplates: boolean;
  includedStudyCount: number;
};

const ReviewSummaryContext = createContext<ReviewSummaryState>({
  hasExtractionTemplates: false,
  includedStudyCount: 0,
});

export const useReviewSummaryContext = () => useContext(ReviewSummaryContext);

export default ReviewSummaryContext;
